export function buildWhatsAppLink(phone, message) {
  const digits = (phone || "").replace(/[^0-9]/g, "");
  const withCountry = digits.startsWith("0") ? `62${digits.slice(1)}` : digits;
  return `https://wa.me/${withCountry}?text=${encodeURIComponent(message)}`;
}

export function openWhatsApp(phone, message) {
  if (!phone) return;
  window.open(buildWhatsAppLink(phone, message), "_blank");
}
